import { AxiosStatic } from "axios";
import { QuestionConfig, CustomQuestionConfig, QuestionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { AdditionalQuestionCreateModel } from "./model";

export class QuestionnaireConfigApi {
    private axios: AxiosStatic;

    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    public async get(customerId: string, questionnaireType: string) {
        const response = await this.axios.get<{ questions: QuestionConfig[]; additionalQuestions: CustomQuestionConfig[] }>(
            `/api/customer/${customerId}/questionnaireconfig/${questionnaireType}`
        );
        return response.data;
    }

    public async getTermsAndConditionsOfUseDefaultText() {
        const response = await this.axios.get<CustomQuestionConfig>(
            "/api/questionnaireconfig/TermsAndConditionsOfUseDefaultText"
        );
        return response.data;
    }

    public save(customerId: string, questionnaireType: string, questionnaireConfig: QuestionnaireConfig) {
        return this.axios.put<{ questions: QuestionConfig[] }>(`/api/customer/${customerId}/questionnaireconfig/${questionnaireType}`, questionnaireConfig);
    }

    public async createQuestion(customerId: string, questionnaireType: string, question: AdditionalQuestionCreateModel) {
        const response = await this.axios.post<{ id: string; questionText: string }>(
            `/api/customer/${customerId}/questionnaireconfig/${questionnaireType}/additionalQuestions`,
            question
        );
        return response.data;
    }

    public async removeQuestion(customerId: string, questionnaireType: string, questionId: string) {
        await this.axios.delete(`/api/customer/${customerId}/questionnaireconfig/${questionnaireType}/additionalQuestions/${questionId}`);
    }
}
